import config from '@/config';
import api from '@/shared/api';
import { useMutation } from '@tanstack/react-query';
import { useIntl } from 'react-intl';
import handleHttpError from '@/shared/services/HandleHttpError';
export var useSendTaskMail = function () {
    var intl = useIntl();
    var _a = useMutation(function (values) {
        return api.base
            .post("".concat(config.appUrls.api, "/api/template/sendTaskMail"), values)
            .then(function (res) { return res.data; });
    }, {
        onError: function (e) {
            handleHttpError(intl)(e);
        },
    }), mutateAsync = _a.mutateAsync, isLoading = _a.isLoading, error = _a.error;
    return {
        sendTaskMail: mutateAsync,
        isLoading: isLoading,
        error: error,
    };
};
